<template>
  <div class="tabs-head">
    <slot></slot>
    <div class="line" ref="line"></div>
    <div class="actions-wrapper">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "KilokTabsHead",
  inject: ["eventBus"],

  created() {
    if(this.eventBus){
      this.eventBus.$on("update:selected", (item, vm) => {
        let { width,left,top,height } = vm.$el.getBoundingClientRect();
      this.$refs.line.style.width = `${width}px`;
      this.$refs.line.style.top = `${top+height}px`;
      this.$refs.line.style.left = `${left}px`;
    });
    }
  },
};
</script>
<style scoped lang="scss">
$tab-height: 40px;
$blue: rgba(110, 163, 224);
$border-color: #ddd;
.tabs-head {
  display: flex;
  height: $tab-height;
  justify-content: flex-start;
  border-bottom: 1px solid $border-color;

  > .line {
    position: absolute;
    border-bottom: 1px solid $blue;
    transition: all 250ms;
  }
  > .actions-wrapper {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1em;
  }
}
</style>
